import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import './HomeButton.css';

const styles = () => ({
  fabRoot: {
    position: 'fixed',
    top: '80px',
    left: '20px',
    zIndex: -1,
  },
  fabRootTablet: {
    position: 'fixed',
    top: '100px',
    right: '20px',
    zIndex: -1,
  },
  enabled: {},
  listIcon: {
    marginTop: '10px',
  },
});

class HomeButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: this.props.active,
      hovered: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      this.setState({ active: this.props.active });
    }
  }

  render() {
    const hoverBackground = this.props.hoverBackgroundColor
      ? this.props.hoverBackgroundColor
      : 'black';

    let style =
      this.state.active || this.state.hovered
        ? {
            color: hoverBackground,
          }
        : { color: 'black' };

    return (
      <>
        <div
          className={'home-btn-container'}
          onMouseEnter={() => this.setState({ hovered: true })}
          onMouseLeave={() => this.setState({ hovered: false })}
          onMouseDown={() => this.props.onClickHandler()}
        >
          <div className={'home-btn-txt-container'}>
            <div style={style} className={'home-btn-txt'}>
              {this.props.title}
            </div>
            <div className={'home-btn-txt-sub'}>{this.props.subtitle}</div>
          </div>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(HomeButton);
